import { FC } from "react";
import { Box, Text } from "@chakra-ui/react";
import { successColor } from "../../../utils/colors";
import { borderRadius } from "../../../utils/styles/styles";

interface FieldOccurencesStateProps {
  stateValue: boolean | null;
  additionalStyle?: object;
  hasBackground?: boolean;
}

const FieldOccurencesState: FC<FieldOccurencesStateProps> = ({
  stateValue,
  additionalStyle = {},
  hasBackground = true,
}) => {
  let color: string;
  let label: string;

  if (stateValue === true) {
    color = "gray.500";
    label = "A decorrer";
  } else if (stateValue === false) {
    color = successColor;
    label = "Terminado";
  } else {
    color = "gray.700";
    label = "Não aplicável";
  }
  return (
    <Box
      fontWeight="bold"
      backgroundColor={hasBackground ? color : "transparent"}
      mr="4"
      style={additionalStyle}
      borderRadius={borderRadius}
    >
      <Text
        px="1"
        textTransform="uppercase"
        fontSize="sm"
        color={hasBackground ? "white" : color}
      >
        {label}
      </Text>
    </Box>
  );
};

export default FieldOccurencesState;
